import { render } from "./product_card.vue?vue&type=template&id=0b0342e1"
import script from "./product_card.vue?vue&type=script&lang=js"
export * from "./product_card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__